module.exports = __webpack_public_path__ + "static/diane-power-e91796ae23092c7c110b59fb845767fa.png";